import Hero from '../components/Hero';
import FeaturesSection from '../components/FeaturesSection';
import AboutSection from '../components/AboutSection';
import HowItWorksSection from '../components/HowItWorksSection';
import CTASection from '../components/CTASection';

function LandingPage() {
    return (
        <>
            <Hero />
            <FeaturesSection />
            <AboutSection />
            <HowItWorksSection />
            <CTASection />
        </>
    );
}

export default LandingPage;
